import request from '../utils/request';

// 分页查询用户地址
export function pageUserAddresses(params) {
  return request({
    url: '/user-address/page',
    method: 'get',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      ...params
    }
  });
}

// 删除用户地址
export function deleteUserAddress(addressId) {
  return request({
    url: `/user-address/${addressId}`,
    method: 'delete'
  });
}

// 设置默认地址
export function setDefaultAddress(addressId, userId) {
  return request({
    url: '/user-address/default',
    method: 'put',
    params: {
      addressId,
      userId
    }
  });
} 